import styled from 'styled-components'

export const Container = styled.div`
	display: grid;
	place-items: center;
	margin: auto;
	height: 70vh;
`

export const Content = styled.div`
	width: 100%;
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	color: #64778f;

	svg {
		width: 108px;
		height: 108px;
		margin-bottom: 20px;
	}

	h4 {
		margin-bottom: 10px;
	}
`
